import { Dispatch, FC, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import useParticipantSignatureModal from './ParticipantSignatureModal.hook';
import DialogForm from 'components/DialogForm';
import { ParticipantMatchField } from 'generated/event.types';
import Box from 'yoda-ui/components/Box';
import { YodaBorderRadius, YodaColors } from 'yoda-ui/yodaTheme';

type ParticipantSignatureModalProps = {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  participantId: string;
  eventId: string;
  matchField?: ParticipantMatchField;
  firstName: string;
  lastName: string;
  onSigned: () => void;
};

const ParticipantSignatureModal: FC<ParticipantSignatureModalProps> = ({
  open,
  setOpen,
  participantId,
  eventId,
  matchField,
  firstName,
  lastName,
  onSigned,
}) => {
  const { t } = useTranslation();
  const {
    canvasRef,
    cancelButtonConfig,
    submitButtonConfig,
  } = useParticipantSignatureModal({ participantId, eventId, matchField, setOpen, onSigned });

  return open ? (
    <DialogForm
      dialogTitle={ `${t('participant_signature_modal_title')} - ${firstName} ${lastName}` }
      open={ open }
      setOpen={ setOpen }
      cancelButtonConfig={ cancelButtonConfig }
      submitButtonConfig={ submitButtonConfig }
      fullWidth
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        width="100%"
        border={ `1px solid ${YodaColors.gray2}` }
        borderRadius={ YodaBorderRadius.small }
        overflow="hidden"
      >
        <canvas
          ref={ canvasRef }
          style={ { width: '100%', height: '300px', touchAction: 'none', background: YodaColors.white } }
        />
      </Box>
    </DialogForm>
  ) : null;
};

export default ParticipantSignatureModal;
